import { Component, Input, OnInit } from '@angular/core';
import { GlobalConstants } from '../../../../core/constants/globals';
import { AttachmentFile } from '../../../../core/models/attachment-file.model';
import { Attachment } from '../../../../core/models/attachment.model';

@Component({
    selector: 'app-attachments-list',
    templateUrl: './attachments-list.component.html',
    styleUrls: ['./attachments-list.component.css']
})
export class AttachmentsListComponent implements OnInit {
    @Input() attachmentList: (Attachment | AttachmentFile)[];
    @Input() requestId: number;
    @Input() reportId: number;
    @Input() action: string;
    @Input() commentId;
    @Input() moduleName: string = '';
    @Input() viewType;
    addAttachment = GlobalConstants.ADD_ATTACHMENT_ACTION;

    constructor() {}

    ngOnInit(): void {}

    getTotalSizeInMB(): number {
        if (!this.attachmentList || this.attachmentList.length === 0) return 0;
        
        const totalSizeInBytes = this.attachmentList.reduce((total, file) => {
            return total + (file.size || 0);
        }, 0);
        
        return totalSizeInBytes / (1024 * 1024);
    }

    isSizeExceedsLimit(): boolean {
        return this.getTotalSizeInMB() > 15;
    }
}
